// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Container */
.elder-bidding-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

/* === LIST PAGE STYLES === */
.bidding-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 900px;
    margin: 0 auto;
    width: 100%;
}

.bidding-strip-card {
    cursor: default !important;
    /* Non-clickable main body */
}

.status-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.05rem;
    font-weight: 600;
    margin-top: 0.25rem;
}

.text-green {
    color: #059669;
}

.text-gray {
    color: #64748b;
}

.live-dot {
    height: 12px;
    width: 12px;
    background-color: #ef4444;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
}

/* === NEW: HUB RESULTS SUMMARY STYLES === */
.results-summary-mini {
    margin-top: 0.75rem;
    background: #f0fdf4;
    padding: 0.75rem 1rem;
    border-radius: 10px;
    border: 1px solid #bbf7d0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.results-summary-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #15803d;
    font-weight: 700;
}

.results-summary-text {
    font-size: 0.9rem;
    color: #166534;
    margin-top: 0.25rem;
}

.results-summary-awaiting {
    font-size: 0.9rem;
    color: #b45309;
    margin-top: 0.25rem;
}

/* Animations */
@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(239, 68, 68, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
    }
}

.spin-slow {
    animation: spin 3s linear infinite;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

/* Buttons */
.enter-room-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #10b981;
}

.enter-room-btn:hover {
    background: #059669;
}

/* === LIVE BIDDING ROOM STYLES === */
.room-container {
    height: 100vh;
    overflow: hidden;
    /* Prevent body scroll, let chat area scroll */
}

.room-main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    margin: 0 auto;
    width: 100%;
    padding: 0 1rem;
    height: calc(100vh - 90px);
}

.room-info-panel {
    background: white;
    border-radius: 12px;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    margin-bottom: 1rem;
    flex-shrink: 0;
}

.info-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.1rem;
    color: #334155;
}

/* Chat-style Feed */
.bids-feed-container {
    flex: 1 1;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    padding: 1.5rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.bids-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.bid-bubble {
    display: flex;
    flex-direction: column;
    min-width: 200px;
    max-width: 80%;
    padding: 1rem 1.5rem;
    border-radius: 16px;
    position: relative;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.my-bid {
    align-self: flex-end;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-bottom-right-radius: 4px;
}

.other-bid {
    align-self: flex-start;
    background: white;
    border: 1px solid #e2e8f0;
    border-bottom-left-radius: 4px;
}

.highest-bid {
    border: 2px solid #f59e0b;
    box-shadow: 0 4px 10px rgba(245, 158, 11, 0.15);
}

.bid-name {
    font-size: 0.95rem;
    color: #64748b;
    font-weight: 700;
    margin-bottom: 0.25rem;
}

.my-bid .bid-name {
    color: #2563eb;
    text-align: right;
}

.bid-amount {
    font-size: 1.8rem;
    font-weight: 800;
    color: #1e293b;
    letter-spacing: -0.5px;
}

.bid-time {
    font-size: 0.85rem;
    color: #94a3b8;
    margin-top: 0.5rem;
    text-align: right;
}

/* Input Form */
.place-bid-panel {
    background: white;
    padding: 1.5rem;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    flex-shrink: 0;
}

.bid-form {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.bid-input-wrapper {
    flex: 1 1;
    position: relative;
    display: flex;
    align-items: center;
}

.input-rupee {
    position: absolute;
    left: 1rem;
    color: #475569;
}

.elder-bid-input {
    width: 100%;
    padding: 1.25rem 1rem 1.25rem 3rem;
    font-size: 1.4rem;
    font-weight: 700;
    border: 2px solid #cbd5e1;
    border-radius: 12px;
    color: #1e293b;
    outline: none;
    transition: border-color 0.2s;
}

.elder-bid-input:focus {
    border-color: #2563eb;
}

.submit-bid-btn {
    padding: 1.25rem 2.5rem;
    font-size: 1.2rem;
    border-radius: 12px;
}

.room-closed-alert {
    text-align: center;
    font-size: 1.2rem;
    color: #dc2626;
    font-weight: 700;
    padding: 1rem;
}

/* Add this anywhere in Bidding.css */
.month-badge {
    background: #e0e7ff;
    color: #1e40af;
    padding: 0.25rem 0.75rem;
    border-radius: 99px;
    font-size: 0.85rem;
    font-weight: 700;
    border: 1px solid #bfdbfe;
    white-space: nowrap;
}

/* === MOBILE === */
@media (max-width: 768px) {
    .bidding-strip-card {
        flex-direction: column;
        align-items: flex-start;
    }

    .list-card-left,
    .list-card-right,
    .enter-room-btn {
        width: 100%;
        justify-content: center;
    }

    .room-info-panel {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }

    .bid-form {
        flex-direction: column;
    }

    .submit-bid-btn {
        width: 100%;
    }

    .room-main {
        height: calc(100vh - 80px);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/member/Bidding.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA,4CAA4C;AAC5C;IACI,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;;IAEA;QACI,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,wCAAwC;IAC5C;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,SAAO;IACP,oCAAoC;IACpC,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,eAAe;IACf,4BAA4B;IAC5B,2CAA2C;IAC3C,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA,qCAAqC;AACrC;IACI,mBAAmB;IACnB,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;;;QAGI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Shared Container */\n.elder-bidding-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n/* === LIST PAGE STYLES === */\n.bidding-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 900px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.bidding-strip-card {\n    cursor: default !important;\n    /* Non-clickable main body */\n}\n\n.status-indicator {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 1.05rem;\n    font-weight: 600;\n    margin-top: 0.25rem;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.text-gray {\n    color: #64748b;\n}\n\n.live-dot {\n    height: 12px;\n    width: 12px;\n    background-color: #ef4444;\n    border-radius: 50%;\n    animation: pulse 1.5s infinite;\n}\n\n/* === NEW: HUB RESULTS SUMMARY STYLES === */\n.results-summary-mini {\n    margin-top: 0.75rem;\n    background: #f0fdf4;\n    padding: 0.75rem 1rem;\n    border-radius: 10px;\n    border: 1px solid #bbf7d0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.results-summary-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: #15803d;\n    font-weight: 700;\n}\n\n.results-summary-text {\n    font-size: 0.9rem;\n    color: #166534;\n    margin-top: 0.25rem;\n}\n\n.results-summary-awaiting {\n    font-size: 0.9rem;\n    color: #b45309;\n    margin-top: 0.25rem;\n}\n\n/* Animations */\n@keyframes pulse {\n    0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);\n    }\n\n    70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 6px rgba(239, 68, 68, 0);\n    }\n\n    100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);\n    }\n}\n\n.spin-slow {\n    animation: spin 3s linear infinite;\n}\n\n@keyframes spin {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* Buttons */\n.enter-room-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #10b981;\n}\n\n.enter-room-btn:hover {\n    background: #059669;\n}\n\n/* === LIVE BIDDING ROOM STYLES === */\n.room-container {\n    height: 100vh;\n    overflow: hidden;\n    /* Prevent body scroll, let chat area scroll */\n}\n\n.room-main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    max-width: 800px;\n    margin: 0 auto;\n    width: 100%;\n    padding: 0 1rem;\n    height: calc(100vh - 90px);\n}\n\n.room-info-panel {\n    background: white;\n    border-radius: 12px;\n    padding: 1rem 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    border: 1px solid #e2e8f0;\n    margin-bottom: 1rem;\n    flex-shrink: 0;\n}\n\n.info-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 1.1rem;\n    color: #334155;\n}\n\n/* Chat-style Feed */\n.bids-feed-container {\n    flex: 1;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    padding: 1.5rem;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1rem;\n}\n\n.bids-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.bid-bubble {\n    display: flex;\n    flex-direction: column;\n    min-width: 200px;\n    max-width: 80%;\n    padding: 1rem 1.5rem;\n    border-radius: 16px;\n    position: relative;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.my-bid {\n    align-self: flex-end;\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    border-bottom-right-radius: 4px;\n}\n\n.other-bid {\n    align-self: flex-start;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-bottom-left-radius: 4px;\n}\n\n.highest-bid {\n    border: 2px solid #f59e0b;\n    box-shadow: 0 4px 10px rgba(245, 158, 11, 0.15);\n}\n\n.bid-name {\n    font-size: 0.95rem;\n    color: #64748b;\n    font-weight: 700;\n    margin-bottom: 0.25rem;\n}\n\n.my-bid .bid-name {\n    color: #2563eb;\n    text-align: right;\n}\n\n.bid-amount {\n    font-size: 1.8rem;\n    font-weight: 800;\n    color: #1e293b;\n    letter-spacing: -0.5px;\n}\n\n.bid-time {\n    font-size: 0.85rem;\n    color: #94a3b8;\n    margin-top: 0.5rem;\n    text-align: right;\n}\n\n/* Input Form */\n.place-bid-panel {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 16px 16px 0 0;\n    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.05);\n    border: 1px solid #e2e8f0;\n    flex-shrink: 0;\n}\n\n.bid-form {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n}\n\n.bid-input-wrapper {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.input-rupee {\n    position: absolute;\n    left: 1rem;\n    color: #475569;\n}\n\n.elder-bid-input {\n    width: 100%;\n    padding: 1.25rem 1rem 1.25rem 3rem;\n    font-size: 1.4rem;\n    font-weight: 700;\n    border: 2px solid #cbd5e1;\n    border-radius: 12px;\n    color: #1e293b;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.elder-bid-input:focus {\n    border-color: #2563eb;\n}\n\n.submit-bid-btn {\n    padding: 1.25rem 2.5rem;\n    font-size: 1.2rem;\n    border-radius: 12px;\n}\n\n.room-closed-alert {\n    text-align: center;\n    font-size: 1.2rem;\n    color: #dc2626;\n    font-weight: 700;\n    padding: 1rem;\n}\n\n/* Add this anywhere in Bidding.css */\n.month-badge {\n    background: #e0e7ff;\n    color: #1e40af;\n    padding: 0.25rem 0.75rem;\n    border-radius: 99px;\n    font-size: 0.85rem;\n    font-weight: 700;\n    border: 1px solid #bfdbfe;\n    white-space: nowrap;\n}\n\n/* === MOBILE === */\n@media (max-width: 768px) {\n    .bidding-strip-card {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .list-card-left,\n    .list-card-right,\n    .enter-room-btn {\n        width: 100%;\n        justify-content: center;\n    }\n\n    .room-info-panel {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.75rem;\n    }\n\n    .bid-form {\n        flex-direction: column;\n    }\n\n    .submit-bid-btn {\n        width: 100%;\n    }\n\n    .room-main {\n        height: calc(100vh - 80px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
